import MuiDialogActions from '@mui/material/DialogActions';
import { ReactNode } from 'react';

const DialogActions = ({ children }: { children: ReactNode }) => {
    return (
        <MuiDialogActions sx={{ '& :only-child': { marginLeft: 'auto' } }}>
            {children}
        </MuiDialogActions>
    );
};

export default DialogActions;
